import { useDispatch } from 'react-redux';
import { useCookies } from 'react-cookie';
import { HEADER_BAR_BANNER_COOKIE, Banners } from '../../redux/banners/types';
import { hideBanner } from '../../redux/banners/actions';
import usePersistedFlag from './usePersistedFlag';

const useHeaderBarBanner = (): [boolean, (ttl?: number) => void, () => void] => {
    const [status, setStatus] = usePersistedFlag(HEADER_BAR_BANNER_COOKIE, true);
    const dispatch = useDispatch();

    const isDismissed = !!status;
    const dismissHeaderBarBanner = (ttl?: number) => {
        setStatus(1, ttl);
        dispatch(hideBanner(Banners.HEADER_BAR_BANNER));
    };

    const resetHeaderBarBannerCookie = () => {
        setStatus(0);
    };

    return [isDismissed, dismissHeaderBarBanner, resetHeaderBarBannerCookie];
};

const PREVIOUS_HEADER_BAR_BANNER_ID = 'previous_hbb_id';
export const usePreviousHeaderBarID = (): [string, (current: string) => void] => {
    const [previousHeaderBar, setStatus] = useCookies([PREVIOUS_HEADER_BAR_BANNER_ID]);

    const previousId = previousHeaderBar[PREVIOUS_HEADER_BAR_BANNER_ID];
    const setCurrentHeaderBannerId = (currentHeaderBar: string) => {
        setStatus(PREVIOUS_HEADER_BAR_BANNER_ID, currentHeaderBar);
    };

    return [previousId, setCurrentHeaderBannerId];
};

export default useHeaderBarBanner;
